import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "@mui/material";
import { MembershipType } from "@ssf/memdb-api";
import { Shield } from "mdi-material-ui";
import { useTranslation } from "react-i18next";
export const MembershipShield = ({ membershiptype, documentid, disableTooltip = false, }) => {
    const { t } = useTranslation("MembershipShield");
    const isOfficialMember = membershiptype < MembershipType.NoneOfficialMember;
    const title = t(isOfficialMember
        ? "officialMember"
        : documentid
            ? "hasSignature"
            : "noneOfficialMember").toString();
    return (_jsx(Tooltip, { title: disableTooltip ? "" : title, placement: "left", disableInteractive: true, children: _jsx(Shield, { tabIndex: disableTooltip ? undefined : 0, titleAccess: title, sx: {
                color: ({ palette }) => isOfficialMember
                    ? palette.success.main
                    : documentid
                        ? palette.info.main
                        : palette.grey[400],
            } }) }));
};
//# sourceMappingURL=MembershipShield.js.map